export default __webpack_public_path__ + "static/thumbnail-763999ae2c679450926c9970ea912b3a.jpg";